/**
 * Utility for parsing _liked_by field
 * 
 * Handles various formats:
 * - JSON string: '["user1@example.com","user2@example.com"]'
 * - Array: ["user1@example.com","user2@example.com"]
 * - null/undefined: []
 */

export function parseLikedBy(value: unknown): string[] {
  if (!value) return [];
  if (Array.isArray(value)) return value as string[];
  if (typeof value === "string") {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}

